(function () {
  const originalFetch = window.fetch.bind(window);
  let lastSubmittedForm = null;

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[data-type="add-to-cart-form"]')) {
      lastSubmittedForm = event.target;
    }
  }, true);

  function cloneFormData(source) {
    const copy = new FormData();
    for (const [key, value] of source.entries()) {
      copy.append(key, value);
    }
    return copy;
  }

  function formDataFor(source, quantity, fulfillment) {
    const copy = cloneFormData(source);
    copy.set('quantity', String(quantity));
    copy.delete('properties[Fulfillment]');
    copy.append('properties[Fulfillment]', fulfillment);
    return copy;
  }

  function getInventory(variantId, form) {
    const idInput = form && form.querySelector('[name="id"]');
    const hasInventoryHint = idInput && String(idInput.value) === String(variantId)
      && idInput.dataset.inventoryQuantity !== undefined;

    if (hasInventoryHint) {
      return Promise.resolve({
        tracked: idInput.dataset.inventoryTracked === 'true',
        stock: Math.max(0, Number(idInput.dataset.inventoryQuantity) || 0)
      });
    }

    return originalFetch('/variants/' + encodeURIComponent(variantId) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Inventory lookup failed');
      return response.json();
    }).then(function (variant) {
      return {
        tracked: variant.inventory_management === 'shopify',
        stock: Math.max(0, Number(variant.inventory_quantity) || 0)
      };
    });
  }

  function splitQuantity(inventory, quantity) {
    const requested = Math.max(1, Number(quantity) || 1);

    if (!inventory.tracked) {
      return { available: requested, special: 0 };
    }

    return {
      available: Math.min(requested, inventory.stock),
      special: Math.max(0, requested - inventory.stock)
    };
  }

  function responseHasCartError(response) {
    if (!response || !response.ok) return Promise.resolve(true);

    return response.clone().json().then(function (data) {
      return Boolean(data && data.status);
    }).catch(function () {
      return false;
    });
  }

  function addSplitLines(url, options, formData) {
    const variantId = formData.get('id');
    const quantity = Number(formData.get('quantity')) || 1;

    if (!variantId) {
      return originalFetch(url, options);
    }

    return getInventory(variantId, lastSubmittedForm).then(function (inventory) {
      const split = splitQuantity(inventory, quantity);

      if (split.special === 0) {
        return originalFetch(url, {
          ...options,
          body: formDataFor(formData, split.available, 'Available Now')
        });
      }

      const addSpecialOrder = function () {
        return originalFetch(url, {
          ...options,
          body: formDataFor(formData, split.special, 'Special Order')
        });
      };

      if (split.available === 0) {
        return addSpecialOrder();
      }

      return originalFetch(url, {
        ...options,
        body: formDataFor(formData, split.available, 'Available Now')
      }).then(function (firstResponse) {
        return responseHasCartError(firstResponse).then(function (hasError) {
          return hasError ? firstResponse : addSpecialOrder();
        });
      });
    }).catch(function () {
      return originalFetch(url, options);
    });
  }

  function addSpecialOrderAfterChange(url, options, changeBody, item, stock) {
    const availableQuantity = Math.min(Number(changeBody.quantity) || 0, stock);
    const specialQuantity = Math.max(0, (Number(changeBody.quantity) || 0) - stock);
    const limitedChange = { ...changeBody, quantity: availableQuantity };

    return originalFetch(url, {
      ...options,
      body: JSON.stringify(limitedChange)
    }).then(function (firstResponse) {
      return responseHasCartError(firstResponse).then(function (hasError) {
        if (hasError || specialQuantity === 0) return firstResponse;

        const properties = { ...(item.properties || {}) };
        properties.Fulfillment = 'Special Order';

        const addBody = {
          items: [{
            id: item.variant_id,
            quantity: specialQuantity,
            properties: properties
          }],
          sections: changeBody.sections,
          sections_url: changeBody.sections_url
        };

        return originalFetch(window.routes.cart_add_url, {
          ...options,
          body: JSON.stringify(addBody)
        });
      });
    });
  }

  window.fetch = function (url, options) {
    const requestUrl = typeof url === 'string' ? url : url && url.url;
    const requestOptions = options || {};

    if (!requestUrl || !requestOptions.body) {
      return originalFetch.apply(window, arguments);
    }

    if (requestUrl.includes('/cart/add')) {
      if (requestOptions.body instanceof FormData) {
        return addSplitLines(requestUrl, requestOptions, requestOptions.body);
      }

      return originalFetch.apply(window, arguments);
    }

    if (requestUrl.includes('/cart/change')) {
      let changeBody;

      try {
        changeBody = JSON.parse(requestOptions.body);
      } catch (error) {
        return originalFetch.apply(window, arguments);
      }

      const lineNumber = Number(changeBody.line);
      const requestedQuantity = Number(changeBody.quantity);

      if (!lineNumber || !Number.isFinite(requestedQuantity) || requestedQuantity < 0) {
        return originalFetch.apply(window, arguments);
      }

      return originalFetch(window.routes.cart_url + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        const item = cart.items && cart.items[lineNumber - 1];
        const currentFulfillment = item && item.properties && item.properties.Fulfillment;

        if (!item || currentFulfillment !== 'Available Now' || requestedQuantity === 0) {
          return originalFetch(requestUrl, requestOptions);
        }

        return getInventory(item.variant_id).then(function (inventory) {
          if (!inventory.tracked || requestedQuantity <= inventory.stock) {
            return originalFetch(requestUrl, requestOptions);
          }

          return addSpecialOrderAfterChange(
            requestUrl,
            requestOptions,
            changeBody,
            item,
            inventory.stock
          );
        });
      }).catch(function () {
        return originalFetch(requestUrl, requestOptions);
      });
    }

    return originalFetch.apply(window, arguments);
  };
})();